function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 11.429,
  cy: 11.429,
  r: 11.429,
  transform: "matrix(-1 0 0 1 36.428 0)",
  fill: "#B0B8CE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 38.533a4 4 0 012.655-3.767l6.246-2.23a33 33 0 0122.198 0l6.246 2.23A4 4 0 0145 38.533v9.161a2 2 0 01-2.283 1.98l-13.899-1.986a26.994 26.994 0 00-7.636 0l-13.9 1.986A2 2 0 015 47.694v-9.16z",
  fill: "#B0B8CE"
});

function SvgUserProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgUserProfile;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/UserProfile.svg
// module id = 1322
// module chunks = 10